/* eslint-disable */
import { HttpClient, RequestParams } from "./http-client";

export class Admin<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  verifySecret = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Admin/VerifySecret`, method: "GET", secure: true, ...params });
  meta = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/Admin/Meta`, method: "GET", secure: true, ...params });
}
